import axios from 'axios';
import {token} from '../services/Authentication'

export default class EstructMenuService {


  static info() {          
    
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_URL_CRM}/user/info`,
      headers: {              
        "authorization": token(), 
      }
    })
    .then((res) => res, (error) => {throw error})
  }

  static infoByToken(param) {                  
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_URL_CRM}/user/info`,
      headers: {              
        "authorization": param, 
      }
    })
    .then((res) => res, (error) => {throw error})
  }

  static itemsMenu(param) {      
    return axios({
      method: 'get',
      url: `${process.env.REACT_APP_URL_DATASET}/setting`,
      headers: {              
        "authorization": token(), 
      },      
    })
    .then((res) => res, (error) => {throw error})
  }
}